import { render, staticRenderFns } from "./TaskItemComponent.vue?vue&type=template&id=be2cf188&scoped=true&"
import script from "./TaskItemComponent.vue?vue&type=script&lang=js&"
export * from "./TaskItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskItemComponent.vue?vue&type=style&index=0&id=be2cf188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2cf188",
  null
  
)

export default component.exports